<template>
    <div>
        <v-dialog v-model="open" persistent max-width="600">
            <v-card>
                <v-toolbar :elevation="0" color="primary" dark>
                    <v-toolbar-title v-if="id">Editar widget</v-toolbar-title>
                    <v-toolbar-title v-else>Añadir widget</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="close">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-btn @click="test">test</v-btn>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="blue-grey lighten-1"
                        dark
                        small
                        >Cancelar</v-btn
                    >
                    <v-btn 
                        color="accent" 
                        small
                        >Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'formWidget',
    props: ['open', 'meter', 'id'],
    methods:{
        ...mapActions({ newWidget: 'graphs/newWidget'}),
        async test(){
            let res = await this.newWidget({
                meter: this.meter,
                new_widget: { name: 'test'}
            })
        },
        close(){
            this.$emit('close')
        }
    }
}
</script>